import React, { useState } from "react"
import { CaretIcon } from "components/page-components/Icons/small"

export const ExpandableCard = ({ open_by_default, title, children }) => {
  const [cardActiveClass, setCardActiveClass] = useState(
    open_by_default ? " is-expanded" : ""
  )

  const toggleCard = () => {
    setCardActiveClass(cardActiveClass ? "" : "is-expanded")
  }

  return (
    <div className="card is-expandable">
      <header
        className="card-header"
        onClick={toggleCard}
        onKeyPress={toggleCard}
        role="button"
        tabIndex="0"
        aria-label="Toggle Card"
      >
        <div className="card-header-title has-text-mitternachtsblau">
          {title}
        </div>
        <span className="card-header-icon">
          <CaretIcon {...{ rotation: cardActiveClass ? "up" : "down" }} />
        </span>
      </header>
      <div
        className={`card-content has-text-mitternachtsblau ${cardActiveClass}`}
      >
        {children}
      </div>
    </div>
  )
}
